import { InjectionToken } from '@angular/core';
import { AuthService } from './auth-service.interface';

export const AUTH_SERVICE = new InjectionToken<AuthService>('AUTH_SERVICE');
export const PROTECTED_FALLBACK_PAGE_URI = new InjectionToken<string>(
  'PROTECTED_FALLBACK_PAGE_URI'
);
export const PUBLIC_FALLBACK_PAGE_URI = new InjectionToken<string>(
  'PUBLIC_FALLBACK_PAGE_URI'
);
